export default {
    start_free_trial: 'Get Started',
    book_a_demo: 'Book a demo',
    log_in: 'Log in',
    explore: '',
    explore_product: '',
    explore_partner_portal: '',
    app_link_text: 'Go to App',
    dropdowns: [
        {
            label: 'Pricing',
            link: {
                link_type: 'Document',
                uid: 'pricing',
                type: 'pricing_page',
                lang: 'en-lu',
                target: null,
                url: '/lu/pricing',
            },
            show_badge: false,
            dropdown: {
                document: null,
            },
        } as any,
    ],
}
